import GKCharts from "components/GKCharts";
import Highcharts from "highcharts";
import AccessibilityModule from "highcharts/modules/accessibility";
import VennModule from "highcharts/modules/venn";

// Extend Highcharts types for Venn module
declare module "highcharts" {
  interface VennPoint extends Point {
    sets: string[];
  }
}

interface Props {
  fundAName: string;
  fundBName: string;
  overlapPercentage: number;
}

VennModule(Highcharts);
AccessibilityModule(Highcharts);

const PairwiseChat = ({ fundAName, fundBName, overlapPercentage }: Props) => {
  const options = {
    chart: {
      type: "venn",
      height: 300,
      width: 300,
    },

    title: { text: "" },

    plotOptions: {
      venn: {
        dataLabels: {
          enabled: true,
          // eslint-disable-next-line func-names
          formatter: function (this: Highcharts.PointLabelObject): string {
            const vennPoint = this.point as Highcharts.VennPoint;

            if (vennPoint.sets?.length === 2) {
              return `${(overlapPercentage ?? 0).toFixed(2)}%`;
            }
            return "";
          },

          style: {
            fontSize: "18px",
            fontWeight: "700",
            color: "#FFF",
          },
        },
        states: {
          hover: { enabled: false },
          inactive: { opacity: 0.5 },
        },
      },
    },

    accessibility: {
      point: {
        valueDescriptionFormat: "{point.name}: {point.longDescription}.",
      },
    },

    series: [
      {
        type: "venn",
        data: [
          {
            sets: ["A"],
            value: 4,
            color: "var(--primary-700)",
            name: fundAName,
          },
          {
            sets: ["B"],
            value: 4,
            color: "#63A387",
            name: fundBName,
          },
          {
            sets: ["A", "B"],
            value: 1,
            color: "#2fa075ff",
            name: "Overlap",
          },
        ],
      },
    ],

    // tooltip: {
    //   headerFormat:
    //     '<span style="color:{point.color}">\u2022</span> ' +
    //     '<span style="font-size: 14px"> {point.point.name}</span><br/>',
    //   pointFormat:
    //     "{point.longDescription}<br>" +
    //     '<span style="font-size:10px">Source: Wikipedia</span>',
    // },

    legend: {
      enabled: false,
    },
  };

  return <GKCharts chartOptions={options} />;
};

export default PairwiseChat;
